// src/components/Alarme/Bombas/controleBombas/controleBombas.js
import { useState } from "react";
import { sendCommandFlex8 } from "../../../../API/basic/AcionamentoFlex8";
import { iluminacaoConfig } from "../../../../configs/iluminação";
import { useModulosFeedback } from "../../../../hooks/useModulosFeedback";
import "./controleBombas.css";

export default function ControleBombas() {
  // Hook de feedback
  const { 
    isGrupoLigado, 
    loading: feedbackLoading, 
    error: feedbackError
  } = useModulosFeedback();

  // Buscar a configuração do grupo39
  const bombaConfig = iluminacaoConfig.find(item => item.id === "grupo39");

  // Estado de loading só para o grupo39
  const [loading, setLoading] = useState(false);

  if (!bombaConfig) {
    return null; // não renderiza nada se grupo39 não estiver configurado
  }

  // Status real via hook
  const bombaStatus = isGrupoLigado(bombaConfig);

  const handleToggle = async () => {
    const newStatus = !bombaStatus;

    setLoading(true);
    try {
      const comando = {
        modulo: bombaConfig.modulo,
        idx: bombaConfig.idx,
        status: newStatus ? "ON" : "OFF"
      };

      await sendCommandFlex8(bombaConfig.descricao, comando);

      console.log(`${bombaConfig.descricao} ${newStatus ? 'ligada' : 'desligada'}`);
    } catch (error) {
      console.error(`Erro ao acionar ${bombaConfig.descricao}:`, error);
      alert(`Erro ao acionar ${bombaConfig.descricao}`);
    } finally {
      setTimeout(() => setLoading(false), 2000);
    }
  };

  return (
    <div className="grupoAlarme">
      <h3 className="grupoTitulo">
        Painel De Alarmes
        {feedbackLoading && <span className="feedback-status"> (Carregando...)</span>}
        {feedbackError && <span className="feedback-error"> (Erro no feedback)</span>}
      </h3>

      <div className="campo-grupo-alarmes">
        <div className="alarme bomba-spa-control">
          <p className="titleAlarme">{bombaConfig.descricao}</p>
          <p className="bomba-info">Módulo {bombaConfig.modulo} - Índice {bombaConfig.idx}</p>
          <button
            className={`bomba-control-btn ${bombaStatus ? 'bomba-off' : 'bomba-on'} ${loading ? 'loading' : ''}`}
            onClick={handleToggle}
            disabled={loading || feedbackLoading}
          >
            {loading ? (
              <span className="loading-spinner-bombas">⟳</span>
            ) : (
              bombaStatus ? 'DESLIGAR' : 'LIGAR'
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
